module.exports = __webpack_public_path__ + "img/thumbnail_EgyptianFruitBat_u_normal.dd17b603.png";